module.exports = __webpack_public_path__ + "img/user-circle.2b584b2e.svg";